import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import {
  blueGreyMui,
  blueMui,
  MOBILE_BREAKPOINT,
  redMui,
  rydeColors,
  ScreenDepth,
} from "@ryde/theme";

export const FilterMultiselectWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "filter-dropdown-wrapper",
})`
  &.filter-border__highlighted {
    border-radius: 4px;
    outline: 1px solid ${blueMui._300};
    box-shadow: 2px 2px 5px rgba(2, 136, 209, 0.25);
  }

  .menu-button-wrapper {
    svg {
      color: ${blueGreyMui.A200};
    }
  }

  &.filter-border__suspended {
    border-radius: 4px;
    outline: 1px solid ${redMui._700};
    &:hover {
      box-shadow: 2px 2px 5px rgba(255, 0, 0, 0.25);
    }
    .menu-button-text {
      color: ${redMui._400};
    }
    .menu-button-wrapper {
      label {
        color: ${redMui._400};
      }
      svg {
        color: ${redMui._400};
      }
    }
  }

  .FilterMultiSelect__control {
    &:hover {
      border: 1px solid ${rydeColors.reactSelectBlue};
      box-shadow: 0 0 0 1px ${rydeColors.reactSelectBlue};
    }
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    .filter-menu-button {
      width: 100%;
    }
  }
`;

export const BlanketMultiselect = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "blanket-multiselect-wrapper",
})`
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  position: fixed;
  z-index: ${ScreenDepth.HEADER_MULTISELECT_BLANKET};
`;

export const StyledLabelMultiselect = styled.label.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "label-multiselect",
})`
  font-size: 14px;
  text-transform: capitalize;
`;

export const StyledLabelBlack = styled(
  StyledLabelMultiselect,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "label-multiselect-black",
})`
  color: ${rydeColors.black};
`;

export const StyledLabelBlue = styled(
  StyledLabelMultiselect,
).attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "label-multiselect-steel",
})`
  color: ${rydeColors.steel};
`;

export const SelectAllOptionLikeReactSelectStyled = styled.div<{
  $isSelected: boolean;
  $isFocused: boolean;
}>`
  width: 100%;
  user-select: none;
  background-color: ${props => {
    if (props.$isSelected) {
      return blueMui._600;
    }

    return props.$isFocused ? rydeColors.focusedOption : rydeColors.white;
  }};
  color: ${props => (props.$isSelected ? rydeColors.white : "inherit")};
  padding: 8px 12px;
`;

export const SelectNoneOptionLikeReactSelectStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "select-none-option-like-react-select-wrapper",
  },
)`
  width: 100%;
  user-select: none;
  padding: 8px 12px;
  color: inherit;
  background-color: ${rydeColors.white};

  &.isFocused {
    background-color: ${rydeColors.focusedOption};
  }

  &.isSelected {
    color: ${rydeColors.white};
    background-color: ${blueMui._600};
  }
`;
